import { createContext } from 'react';
export var PrintableContext = createContext({
    groupId: 0,
});
